enum Radians {
    Up = Math.atan2(1.0, 0.0),
    Down = Math.atan2(-1.0, 0.0),
    Right = Math.atan2(0.0, 1.0),
    Left = Math.atan2(0.0, -1.0),
    None = NaN
}

export default Radians;